import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ShieldCheck, Loader2 } from 'lucide-react';
import { useSuperUserAuth } from '../../contexts/SuperUserAuthContext';
import './superuser-theme.css';

const SuperUserLogin = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { login } = useSuperUserAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const result = await login(email, password);

    if (result.success) {
      toast.success('Login efetuado com sucesso!');
      navigate('/superadmin');
    } else {
      toast.error(result.message);
    }

    setLoading(false);
  };

  return (
    <div
      className="su-root"
      style={{
        minHeight: '100vh', display: 'flex', alignItems: 'center',
        justifyContent: 'center', padding: '1rem',
      }}
    >
      <div className="su-card" style={{ padding: '2rem', width: '100%', maxWidth: '380px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.875rem', marginBottom: '1.75rem' }}>
          <div style={{
            width: '48px', height: '48px', borderRadius: 'var(--radius-lg)',
            background: 'var(--accent-gradient)', display: 'flex', alignItems: 'center',
            justifyContent: 'center', boxShadow: 'var(--shadow-lg)',
          }}>
            <ShieldCheck size={24} color="#fff" />
          </div>
          <div style={{ textAlign: 'center' }}>
            <h1 style={{ margin: 0, fontSize: '1.25rem', fontWeight: '700', color: 'var(--text-primary)', letterSpacing: '-0.01em' }}>
              GyMag Super Admin
            </h1>
            <p style={{ margin: '0.25rem 0 0', fontSize: '0.8125rem', color: 'var(--text-muted)' }}>
              Painel de gestão de instâncias
            </p>
          </div>
        </div>

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: '1rem' }}>
            <label className="su-label" htmlFor="su-email">Email</label>
            <input
              className="su-input"
              type="email"
              id="su-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="email@exemplo.com"
              autoComplete="username"
              required
            />
          </div>

          <div style={{ marginBottom: '1.5rem' }}>
            <label className="su-label" htmlFor="su-password">Password</label>
            <input
              className="su-input"
              type="password"
              id="su-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              autoComplete="current-password"
              required
            />
          </div>

          <button
            type="submit"
            className="su-btn su-btn-primary"
            style={{ width: '100%', padding: '0.75rem' }}
            disabled={loading}
          >
            {loading && <Loader2 size={16} style={{ animation: 'su-spin 1s linear infinite' }} />}
            {loading ? 'A entrar...' : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default SuperUserLogin;
